import script from "./CatalogYachtEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./CatalogYachtEdit.vue?vue&type=script&setup=true&lang=js"

import "./CatalogYachtEdit.vue?vue&type=style&index=0&id=3b30c742&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b30c742"]])

export default __exports__